const SWITCH_RESET = 'SWITCH_RESET';
const SWITCH_STATE = 'SWITCH_STATE';
const SWITCH_SPEED = 'SWITCH_SPEED';
const SWITCH_DARK_MODE = 'SWITCH_DARK_MODE';
const SWITCH_POSITION = 'SWITCH_POSITION';
const SWITCH_IMAGE_TYPE = 'SWITCH_IMAGE_TYPE';
const SWITCH_MEDIA_TYPE = 'SWITCH_MEDIA_TYPE';
export const switchReset = () => ({ type: SWITCH_RESET });

export const editSwitchState = value => ({
  type: SWITCH_STATE,
  value
});

export const editSwitchSpeed = value => ({
  type: SWITCH_SPEED,
  value
});

export const editSwitchDarkMode = value => ({
  type: SWITCH_DARK_MODE,
  value
});
export const editSwitchPosition = value => ({
  type: SWITCH_POSITION,
  value
});
export const editSwitchImageType = value => ({
  type: SWITCH_IMAGE_TYPE,
  value
});
export const editSwitchMediaType = value => ({
  type: SWITCH_MEDIA_TYPE,
  value
});

const initialState = {
  switchState: false,
  switchSpeed: 2,
  switchDarkMode: true,
  switchPosition: 'up',
  switchImageType: 'quard',
  switchMediaType: 'image'
};

export default function switchButtonReducer(state = initialState, action) {
  switch (action.type) {
    case SWITCH_RESET:
      return initialState;
    case SWITCH_STATE:
      return {
        ...state,
        switchState: action.value
      };
    case SWITCH_SPEED:
      return {
        ...state,
        switchSpeed: action.value
      };
    case SWITCH_DARK_MODE:
      return {
        ...state,
        switchDarkMode: action.value
      };
    case SWITCH_POSITION:
      return {
        ...state,
        switchPosition: action.value
      };
    case SWITCH_IMAGE_TYPE:
      return {
        ...state,
        switchImageType: action.value
      };
    case SWITCH_MEDIA_TYPE:
      return {
        ...state,
        switchMediaType: action.value
      };
    default:
      return state;
  }
}
